import { boolEnv, intEnv, stringEnv } from '@utils/configUtils'

const config = {
    mode: stringEnv('NODE_ENV', process.env.NODE_ENV),
    parseApiBaseUrl: stringEnv('PARSE_API_BASE_URL', process.env.PARSE_API_BASE_URL),
    enableInternalDashboard: boolEnv(
        'ENABLE_INTERNAL_DASHBOARD',
        process.env.ENABLE_INTERNAL_DASHBOARD,
        { defaultValue: false },
    ),
    logRocket: {
        enabled: boolEnv('LOGROCKET_ENABLED', process.env.LOGROCKET_ENABLED, { defaultValue: false }),
        id: stringEnv('LOGROCKET_ID', process.env.LOGROCKET_ID, { defaultValue: null }),
    },
    enablePendo: boolEnv('ENABLE_PENDO', process.env.ENABLE_PENDO, { defaultValue: true }),
    enableHubSpot: boolEnv('ENABLE_HUBSPOT', process.env.ENABLE_HUBSPOT, { defaultValue: true }),
    enablePrivacyPolicyScript: boolEnv(
        'ENABLE_PRIVACY_POLICY',
        process.env.ENABLE_PRIVACY_POLICY,
        { defaultValue: false },
    ),
    enableLinkedInTracking: boolEnv(
        'ENABLE_LINKEDIN_TRACKING',
        process.env.ENABLE_LINKEDIN_TRACKING,
        { defaultValue: false },
    ),
    stripePublicKey: stringEnv('STRIPE_PUBLIC_KEY', process.env.STRIPE_PUBLIC_KEY),
    labelStudioBaseUrl: stringEnv('LS_BASE_URL', process.env.LS_BASE_URL),
    maxFileUploadMb: intEnv('MAX_FILE_UPLOAD_MB', process.env.MAX_FILE_UPLOAD_MB),
    docStatusPollInterval: intEnv('DOC_STATUS_POLL_INTERVAL', process.env.DOC_STATUS_POLL_INTERVAL),
    checkStatusPollInterval: intEnv('CHECK_STATUS_POLL_INTERVAL', process.env.CHECK_STATUS_POLL_INTERVAL),
    elasticSearchIndexJobPollInterval: intEnv(
        'ELASTIC_SEARCH_INDEX_JOB_POLL_INTERVAL',
        process.env.ELASTIC_SEARCH_INDEX_JOB_POLL_INTERVAL,
    ),
    enableDataRouter: boolEnv('ENABLE_DATA_ROUTER',
        process.env.ENABLE_DATA_ROUTER, 
        { defaultValue: false },
    ),
    apollo: {
        devTools: {
            enabled: boolEnv(
                'APOLLO_DEVTOOLS_ENABLED',
                process.env.APOLLO_DEVTOOLS_ENABLED, 
                { defaultValue: false },
            ),
        },
    },
    realtime: {
        ably: {
            apiKey: stringEnv('ABLY_API_KEY', process.env.ABLY_API_KEY),
        },
    },
}

// log.debug('Config loaded', config)

export default config
